// @ts-strict-ignore
import { JsonObject } from '@shared/convert/convert-core';

@JsonObject('ElbridgeDataVO')
export class ElbridgeDataVO {
  public SUPPLIER_ID_GLN;
  public SUPPLIER_ID_DUNS;
  public MANUFACTURER_PID;
  public MANUFACTURER_TYPE_DESCR;
  public INTERNATIONAL_PID;
  public DESCRIPTION_SHORT;
  public PRICE_AMOUNT;
  public CURRENCY;
  public PRICE_QUANTITY;
  public UDX_EDXF_DISCOUNT_GROUP_MANUFACTURER;
  public QUANTITY;
  public ORDER_UNIT;
  public VALIDITY_END;
  public REFNUMBER_CONFIG;


}
